import { Centrifuge } from 'centrifuge';

import { rHandler } from '@/plugins/response-handler';

import ChatService from '@/services/API/ChatService';

import Base from '../Base';
import ChatMessage from './ChatMessage';

const DEFAULT_API = '/chat';

export default class Chat extends Base {
  /**
   * @param {Object} item - Chat item from server
   */
  constructor({
    id,
    url,
    token,
    channel,
    tag,
    hideInitials,
    replyTo,
  }) {
    super(id, DEFAULT_API);

    this.tag = tag;
    this.onMessage = () => {};
    this.onClose = () => {};

    this.hideInitials = hideInitials; // Скрыть инициалы
    this.replyTo = replyTo; // Пользователь, которому отвечают
    this.alertOptions = {};

    if (url) {
      this.centrifuge = new Centrifuge(url, { token });
      const sub = this.centrifuge.newSubscription(channel);
      sub.on('publication', (ctx) => this.onMessage(new ChatMessage(ctx.data.data)));
      sub.subscribe();
      this.centrifuge.connect();
    }
  }

  async setAlertMessage(message) {
    this.alertOptions = {
      message,
    };
  }

  getHistory(offset) {
    const params = {
      sort: '-created_at',
      expand: 'tag,gpt_request',
      offset,
    };
    if (this.tag) {
      params['search[tag][course_id]'] = this.tag.course_id;
      params['search[tag][course_unit_id]'] = this.tag.course_unit_id;
      params['search[tag][lesson_id]'] = this.tag.lesson_id;
    }
    return rHandler(
      ChatService.getMessages(this.id, params),
      (r) => r.data.data.map((i) => new ChatMessage(i)).reverse(),
    );
  }

  sendMessage({ text, replyId }) {
    const data = {
      message: text,
      reply: replyId,
      tag: this.tag,
    };
    if (Object.keys(this.alertOptions).length > 0) {
      this.alertOptions.message.processedMessage();
      this.alertOptions = {};
    }
    return rHandler(
      ChatService.sendMessage(this.id, data),
      (resp) => {
        if (!this.centrifuge) {
          this.onMessage(new ChatMessage(resp.data.data));
        }
      },
    );
  }

  close() {
    return rHandler(
      ChatService.closeChat(this.id),
      () => this.onClose(),
    );
  }

  /**
   * @param {Function} callback - callback function when message has been sent
   */
  bindOnMessage(callback) {
    this.onMessage = callback;
  }

  /**
   * @param {Function} callback - callback function when chat has been closed
   */
  bindOnClose(callback) {
    this.onClose = callback;
  }
}
